import * as React from 'react';

export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
} as const;

type BreakpointKey = keyof typeof BREAKPOINTS;

export function useBreakpoint(breakpoint: BreakpointKey) {
  const [isBelowBreakpoint, setIsBelowBreakpoint] = React.useState<
    boolean | undefined
  >(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(
      `(max-width: ${BREAKPOINTS[breakpoint] - 1}px)`
    );
    const onChange = () => {
      setIsBelowBreakpoint(window.innerWidth < BREAKPOINTS[breakpoint]);
    };
    mql.addEventListener('change', onChange);
    setIsBelowBreakpoint(window.innerWidth < BREAKPOINTS[breakpoint]);
    return () => mql.removeEventListener('change', onChange);
  }, [breakpoint]);

  const loading = isBelowBreakpoint === undefined;
  return [isBelowBreakpoint ?? true, loading] as const;
}

// Convenience hook for mobile screens (md breakpoint)
export function useIsMobile() {
  return useBreakpoint('md');
}

// Convenience hook for large screens (lg breakpoint)
export function useIsLargeScreen() {
  return useBreakpoint('lg');
}
